'use client';

import dynamic from 'next/dynamic';

// Everything below the initial viewport is dynamic-imported so each section lands in its
// own async client chunk instead of being fused into the shared route bundle. Kept with
// ssr: true (default) so the server still streams the section shells — this preserves
// CLS and SEO while deferring the actual JS payload (framer-motion variants, icons, etc).
const Services = dynamic(() => import('@/components/sections/Services'));
const Timeline = dynamic(() => import('@/components/sections/Timeline'));
const Gallery = dynamic(() => import('@/components/sections/Gallery'));
const Testimonials = dynamic(() => import('@/components/sections/Testimonials'));
const Blog = dynamic(() => import('@/components/sections/Blog'));
const Contact = dynamic(() => import('@/components/sections/Contact'));
const CTA = dynamic(() => import('@/components/sections/CTA'));

export default function BelowFoldSections() {
  return (
    <>
      <Services />
      <Timeline />
      <Gallery />
      <Testimonials />
      <Blog />
      <Contact />
      <CTA />
    </>
  );
}
